// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/search.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { AppEntitlementUserBinding } from "../../app/v1/app_entitlement_user_binding";
import { Task } from "./task";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { AppEntitlementUserBindingRef } from "../../app/v1/app_refs";
import { App } from "../../app/v1/app";
import { RevokeOutcome } from "./task";
import { GrantOutcome } from "./task";
import { CertifyOutcome } from "./task";
import { StepApprovalType } from "../../policy/v1/policy_steps_approval";
import { Duration } from "../../../../google/protobuf/duration";
import { TaskRef } from "./task";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { TaskState } from "./task";
import { TaskType } from "./task";
import { Facets } from "../../search/v1/facet";
import { Any } from "../../../../google/protobuf/any";
import { TaskView } from "./task";
import { TaskExpandMask } from "./task";
/**
 * @generated from protobuf message c1.api.task.v1.SearchWaitingOnRequest
 */
export interface SearchWaitingOnRequest {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 2
     */
    expandMask?: TaskExpandMask;
}
/**
 * @generated from protobuf message c1.api.task.v1.SearchWaitingOnResponse
 */
export interface SearchWaitingOnResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView waiting_on_tasks = 1
     */
    waitingOnTasks: TaskView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.task.v1.CountAuditEventTypeErrorRequest
 */
export interface CountAuditEventTypeErrorRequest {
    /**
     * @generated from protobuf field: string task_id = 1
     */
    taskId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.CountAuditEventTypeErrorResponse
 */
export interface CountAuditEventTypeErrorResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.CountCompletedTicketsWithinMonthRequest
 */
export interface CountCompletedTicketsWithinMonthRequest {
    /**
     * @generated from protobuf field: string userId = 1
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.CountCompletedTicketsWithinMonthResponse
 */
export interface CountCompletedTicketsWithinMonthResponse {
    /**
     * @generated from protobuf field: int64 Count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchTermsRequest
 */
export interface TaskSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest search = 1
     */
    search?: TaskSearchRequest;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchTermsRequest.TermType term = 2
     */
    term: TaskSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskSearchTermsRequest.TermType
 */
export enum TaskSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TICKET_STATES = 1;
     */
    TICKET_STATES = 1,
    /**
     * @generated from protobuf enum value: SUBJECT_IDS = 2;
     */
    SUBJECT_IDS = 2,
    /**
     * @generated from protobuf enum value: APPLICATION_IDS = 3;
     */
    APPLICATION_IDS = 3,
    /**
     * @generated from protobuf enum value: APP_RESOURCE_IDS = 4;
     */
    APP_RESOURCE_IDS = 4,
    /**
     * @generated from protobuf enum value: APP_RESOURCE_TYPE_IDS = 5;
     */
    APP_RESOURCE_TYPE_IDS = 5,
    /**
     * @generated from protobuf enum value: ASSIGNEE_IN_IDS = 6;
     */
    ASSIGNEE_IN_IDS = 6,
    /**
     * @generated from protobuf enum value: OPENER_IDS = 7;
     */
    OPENER_IDS = 7,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_IDS = 8;
     */
    ACCESS_REVIEW_IDS = 8,
    /**
     * @generated from protobuf enum value: APP_USER_SUBJECT_IDS = 9;
     */
    APP_USER_SUBJECT_IDS = 9,
    /**
     * @generated from protobuf enum value: ACCOUNT_OWNERS_IDS = 10;
     */
    ACCOUNT_OWNERS_IDS = 10
}
/**
 * @generated from protobuf message c1.api.task.v1.SearchTermsResponse
 */
export interface SearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchCountRequest
 */
export interface TaskSearchCountRequest {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest filter = 1
     */
    filter?: TaskSearchRequest;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchCountByTypeRequest
 */
export interface TaskSearchCountByTypeRequest {
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest filter = 1
     */
    filter?: TaskSearchRequest;
}
/**
 * Search for tasks based on a plethora filters.
 *
 * @generated from protobuf message c1.api.task.v1.TaskSearchRequest
 */
export interface TaskSearchRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Fuzzy search tasks by display name, description, or ID.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * Exclude Specific TaskIDs from this serach result.
     *
     * @generated from protobuf field: repeated string exclude_ids = 6
     */
    excludeIds: string[];
    /**
     * Search tasks with this task type. This is a oneOf, and needs an object, which can be empty, to sort.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskType task_types = 7
     */
    taskTypes: TaskType[];
    /**
     * Search tasks with this task state.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskState task_states = 8
     */
    taskStates: TaskState[];
    /**
     * Search tasks that have any of these apps as targets.
     *
     * @generated from protobuf field: repeated string application_ids = 9
     */
    applicationIds: string[];
    /**
     * Search tasks that were created by any of the users in this array.
     *
     * @generated from protobuf field: repeated string opener_ids = 10
     */
    openerIds: string[];
    /**
     * Search tasks where these users are the subject.
     *
     * @generated from protobuf field: repeated string subject_ids = 11
     */
    subjectIds: string[];
    /**
     * The expand mask takes a list of paths to expand in the response. This might look like ["app", "app_entitlement"]
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 12
     */
    expandMask?: TaskExpandMask;
    /**
     * Search tasks that belong to any of the access reviews included in this list.
     *
     * @generated from protobuf field: repeated string access_review_ids = 15
     */
    accessReviewIds: string[];
    /**
     * Search tasks that have any of these app users as subjects.
     *
     * @generated from protobuf field: repeated string app_user_subject_ids = 16
     */
    appUserSubjectIds: string[];
    /**
     * Search tasks, in RFC3339 format, that were created before this timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_before = 20
     */
    createdBefore?: Timestamp;
    /**
     * Search tasks, in RFC3339 format, that were created after this timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_after = 21
     */
    createdAfter?: Timestamp;
    /**
     * Search tasks by  List of UserIDs which are currently assigned these Tasks
     *
     * @generated from protobuf field: repeated string assignees_in_ids = 22
     */
    assigneesInIds: string[];
    /**
     * Search tasks that were acted on by any of these users.
     *
     * @generated from protobuf field: repeated string previously_acted_on_ids = 23
     */
    previouslyActedOnIds: string[];
    /**
     * Search tasks that have any of these app entitlement IDs.
     *
     * @generated from protobuf field: repeated string app_entitlement_ids = 24
     */
    appEntitlementIds: string[];
    /**
     * Search tasks that do not have any of these app entitlement IDs.
     *
     * @generated from protobuf field: repeated string exclude_app_entitlement_ids = 34
     */
    excludeAppEntitlementIds: string[];
    /**
     * Search tasks that have any of these app resource type IDs.
     *
     * @generated from protobuf field: repeated string app_resource_type_ids = 25
     */
    appResourceTypeIds: string[];
    /**
     * Search tasks that have any of these app resource IDs.
     *
     * @generated from protobuf field: repeated string app_resource_ids = 26
     */
    appResourceIds: string[];
    /**
     * Whether or not to include deleted tasks.
     *
     * @generated from protobuf field: bool include_deleted = 27
     */
    includeDeleted: boolean;
    /**
     * Search tasks where the user would see this task in the My Work section
     *
     * @generated from protobuf field: repeated string my_work_user_ids = 28
     */
    myWorkUserIds: string[];
    /**
     * Sort tasks in a specific order.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskSearchSortBy sort_by = 29
     */
    sortBy: TaskSearchSortBy;
    /**
     * Search tasks that have this actor ID.
     *
     * @generated from protobuf field: string actor_id = 30
     */
    actorId: string;
    /**
     * Search tasks that have this type of step as the current step.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskSearchCurrentStep current_step = 31
     */
    currentStep: TaskSearchCurrentStep;
    /**
     * Search tasks that have any of these account owners.
     *
     * @generated from protobuf field: repeated string account_owner_ids = 32
     */
    accountOwnerIds: string[];
    /**
     * Query tasks by display name, description, or numeric ID.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskRef refs = 33
     */
    refs: TaskRef[];
    /**
     * Search tasks that are or are not emergency access.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest.EmergencyStatusFilter emergency_status = 35
     */
    emergencyStatus: TaskSearchRequest_EmergencyStatusFilter;
    /**
     * @generated from protobuf field: google.protobuf.Duration older_than_duration = 36
     */
    olderThanDuration?: Duration;
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.AppUserType account_types = 37
     */
    accountTypes: AppUserType[];
    /**
     * Search tasks that do not have any of these app resource type IDs.
     *
     * @generated from protobuf field: repeated string exclude_app_resource_type_ids = 38
     */
    excludeAppResourceTypeIds: string[];
    /**
     * Search tasks that have a current policy step of this type
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.StepApprovalType step_approval_types = 39
     */
    stepApprovalTypes: StepApprovalType[];
    /**
     * @generated from protobuf field: repeated string user_employment_statuses = 40
     */
    userEmploymentStatuses: string[];
    /**
     * Search tasks that were opened by this user, or that the user is the subject of.
     *
     * @generated from protobuf field: string opener_or_subject_user_id = 41
     */
    openerOrSubjectUserId: string;
    /**
     * Search tasks that are currently assigned to this user, or that are closed and were previously approved by this user.
     *
     * @generated from protobuf field: string assigned_or_step_approver_user_id = 42
     */
    assignedOrStepApproverUserId: string;
    /**
     * When set with assignees_in_ids, ORs in tasks where user acted after this timestamp
     *
     * @generated from protobuf field: google.protobuf.Timestamp include_acted_after = 43
     */
    includeActedAfter?: Timestamp;
    /**
     * Search tasks by certify outcome
     *
     * @generated from protobuf field: repeated c1.api.task.v1.CertifyOutcome certify_outcomes = 44
     */
    certifyOutcomes: CertifyOutcome[];
    /**
     * Search tasks with outcome after this timestamp
     *
     * @generated from protobuf field: google.protobuf.Timestamp outcome_after = 45
     */
    outcomeAfter?: Timestamp;
    /**
     * Search tasks with outcome before this timestamp
     *
     * @generated from protobuf field: google.protobuf.Timestamp outcome_before = 46
     */
    outcomeBefore?: Timestamp;
    /**
     * Search tasks by grant outcome
     *
     * @generated from protobuf field: repeated c1.api.task.v1.GrantOutcome grant_outcomes = 47
     */
    grantOutcomes: GrantOutcome[];
    /**
     * Search tasks by revoke outcome
     *
     * @generated from protobuf field: repeated c1.api.task.v1.RevokeOutcome revoke_outcomes = 48
     */
    revokeOutcomes: RevokeOutcome[];
    /**
     * Filter tasks by pending action status. Only applies when exactly one access_review_id is specified.
     * Requires the REVIEWS_PENDING_ACTIONS feature flag to be enabled.
     *
     * @generated from protobuf field: c1.api.task.v1.PendingActionFilter pending_action_filter = 49
     */
    pendingActionFilter: PendingActionFilter;
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskSearchRequest.EmergencyStatusFilter
 */
export enum TaskSearchRequest_EmergencyStatusFilter {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The ALL status will show both emergency and non-emergency tasks
     *
     * @generated from protobuf enum value: ALL = 1;
     */
    ALL = 1,
    /**
     * The NON_EMERGENCY status will show all the tasks not marked as an emergency
     *
     * @generated from protobuf enum value: NON_EMERGENCY = 2;
     */
    NON_EMERGENCY = 2,
    /**
     * The EMERGENCY status will show all the tasks marked as an emergency
     *
     * @generated from protobuf enum value: EMERGENCY = 3;
     */
    EMERGENCY = 3
}
/**
 * @generated from protobuf message c1.api.task.v1.GetAllAppsForTaskSearchRequest
 */
export interface GetAllAppsForTaskSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_ids = 2
     */
    excludeIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskType task_types = 3
     */
    taskTypes: TaskType[];
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskState task_states = 4
     */
    taskStates: TaskState[];
    /**
     * Find a Task which was opened by UserIDs
     *
     * @generated from protobuf field: repeated string opener_ids = 5
     */
    openerIds: string[];
    /**
     * Find Tasks which are referncing this C1 UserID
     *
     * @generated from protobuf field: repeated string subject_ids = 6
     */
    subjectIds: string[];
    /**
     * @generated from protobuf field: repeated string access_review_ids = 7
     */
    accessReviewIds: string[];
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 8
     */
    expandMask?: TaskExpandMask;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_before = 9
     */
    createdBefore?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_after = 10
     */
    createdAfter?: Timestamp;
    /**
     * Search tasks by  List of UserIDs which are currently assigned these Tasks
     *
     * @generated from protobuf field: repeated string assignees_in_ids = 12
     */
    assigneesInIds: string[];
    /**
     * Search tasks by a  List of UserIDs which have previously approved or otherwise acted upon this Task
     *
     * @generated from protobuf field: repeated string previously_acted_on_ids = 13
     */
    previouslyActedOnIds: string[];
}
/**
 * @generated from protobuf message c1.api.task.v1.GetAllAppsForTaskSearchResponse
 */
export interface GetAllAppsForTaskSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.App items = 1
     */
    items: App[];
}
/**
 * The TaskSearchResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.task.v1.TaskSearchResponse
 */
export interface TaskSearchResponse {
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView list = 1
     */
    list: TaskView[];
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchCountResponse
 */
export interface TaskSearchCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchCountByTypeResponse
 */
export interface TaskSearchCountByTypeResponse {
    /**
     * @generated from protobuf field: c1.api.task.v1.TicketTypeCounts counts_by_type = 1
     */
    countsByType?: TicketTypeCounts;
    /**
     * @generated from protobuf field: int64 total_count = 2
     */
    totalCount: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.TicketTypeCounts
 */
export interface TicketTypeCounts {
    /**
     * @generated from protobuf field: int64 grant_count = 1
     */
    grantCount: number;
    /**
     * @generated from protobuf field: int64 revoke_count = 2
     */
    revokeCount: number;
    /**
     * @generated from protobuf field: int64 certify_count = 3
     */
    certifyCount: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchGetProgressRequest
 */
export interface TaskSearchGetProgressRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: string access_review_id = 2
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchGetProgressResponse
 */
export interface TaskSearchGetProgressResponse {
    /**
     * @generated from protobuf field: int64 open_count = 1
     */
    openCount: number;
    /**
     * @generated from protobuf field: int64 completed_count = 2
     */
    completedCount: number;
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsRequest
 */
export interface TaskSearchServiceSearchTasksByGrantsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The expand mask takes a list of paths to expand in the response. This might look like ["app", "app_entitlement"]
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 3
     */
    expandMask?: TaskExpandMask;
    /**
     * The task type to search for.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskType task_type = 4
     */
    taskType?: TaskType;
    /**
     * The list of app entitlement user binding refs (grants) to search for.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef app_entitlement_user_binding_refs = 5
     */
    appEntitlementUserBindingRefs: AppEntitlementUserBindingRef[];
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskRef refs = 6
     */
    refs: TaskRef[];
}
/**
 * @generated from protobuf message c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsResponse
 */
export interface TaskSearchServiceSearchTasksByGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView list = 1
     */
    list: TaskView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.RollupEntitlementsWithTasksRequest
 */
export interface RollupEntitlementsWithTasksRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlements = 1
     */
    entitlements: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string user_id = 3
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskRef refs = 6
     */
    refs: TaskRef[];
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.TaskType task_types = 7
     */
    taskTypes: TaskType[];
}
/**
 * @generated from protobuf message c1.api.task.v1.RollupEntitlementsWithTasksResponse
 */
export interface RollupEntitlementsWithTasksResponse {
    /**
     * @generated from protobuf field: repeated c1.api.task.v1.MinTask list = 1
     */
    list: MinTask[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.MinTask
 */
export interface MinTask {
    /**
     * @generated from protobuf field: int64 numeric_id = 1
     */
    numericId: number;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: string entitlement_id = 3
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskType task_type = 5
     */
    taskType?: TaskType;
}
/**
 * @generated from protobuf message c1.api.task.v1.SearchCertifyTicketsByAppViewRequest
 */
export interface SearchCertifyTicketsByAppViewRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The ID of the app to search certify tasks for.
     *
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * Optional list of specific task references to filter by.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskRef refs = 5
     */
    refs: TaskRef[];
    /**
     * The expand mask takes a list of paths to expand in the response.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 6
     */
    expandMask?: TaskExpandMask;
    /**
     * The ID of the access review to filter tasks for.
     *
     * @generated from protobuf field: string access_review_id = 7
     */
    accessReviewId: string;
    /**
     * Filter mode determines how to filter tasks by user.
     *
     * @generated from protobuf oneof: filter_mode
     */
    filterMode: {
        oneofKind: "incomplete";
        /**
         * Incomplete: shows tasks currently assigned to user (stepApproverIds).
         * Optionally includes tasks the user recently acted on (with start_time check).
         *
         * @generated from protobuf field: c1.api.task.v1.IncompleteFilterMode incomplete = 8
         */
        incomplete: IncompleteFilterMode;
    } | {
        oneofKind: "all";
        /**
         * All: shows all tasks where user was involved (stepApproverIds, approverIds, or actorIds).
         *
         * @generated from protobuf field: c1.api.task.v1.AllFilterMode all = 9
         */
        all: AllFilterMode;
    } | {
        oneofKind: undefined;
    };
}
/**
 * Filter for incomplete tasks
 *
 * @generated from protobuf message c1.api.task.v1.IncompleteFilterMode
 */
export interface IncompleteFilterMode {
    /**
     * Optional time threshold for audit check. If provided, includes tasks the user acted on after this time.
     * If not provided, only checks stepApproverIds without joining the audit table.
     *
     * @generated from protobuf field: google.protobuf.Timestamp acted_after = 1
     */
    actedAfter?: Timestamp;
}
/**
 * Filter for all tasks where user was involved
 *
 * No additional fields needed - shows all tasks where user is in stepApproverIds, approverIds, or actorIds.
 *
 * @generated from protobuf message c1.api.task.v1.AllFilterMode
 */
export interface AllFilterMode {
}
/**
 * @generated from protobuf message c1.api.task.v1.SearchCertifyTicketsByAppViewResponse
 */
export interface SearchCertifyTicketsByAppViewResponse {
    /**
     * List of task views containing the certify tasks.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView list = 1
     */
    list: TaskView[];
    /**
     * The list of expanded related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.SearchCertifyTicketsByUserViewRequest
 */
export interface SearchCertifyTicketsByUserViewRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * The ID of the identity user to search certify tasks for. Empty string means accounts with no owner.
     *
     * @generated from protobuf field: string identity_user_id = 3
     */
    identityUserId: string;
    /**
     * Optional list of specific task references to filter by.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskRef refs = 5
     */
    refs: TaskRef[];
    /**
     * The expand mask takes a list of paths to expand in the response.
     *
     * @generated from protobuf field: c1.api.task.v1.TaskExpandMask expand_mask = 6
     */
    expandMask?: TaskExpandMask;
    /**
     * The ID of the access review to filter tasks for.
     *
     * @generated from protobuf field: string access_review_id = 7
     */
    accessReviewId: string;
    /**
     * Filter mode determines how to filter tasks by user.
     *
     * @generated from protobuf oneof: filter_mode
     */
    filterMode: {
        oneofKind: "incomplete";
        /**
         * Incomplete: shows tasks currently assigned to user (stepApproverIds).
         * Optionally includes tasks the user recently acted on (with start_time check).
         *
         * @generated from protobuf field: c1.api.task.v1.IncompleteFilterMode incomplete = 8
         */
        incomplete: IncompleteFilterMode;
    } | {
        oneofKind: "all";
        /**
         * All: shows all tasks where user was involved (stepApproverIds, approverIds, or actorIds).
         *
         * @generated from protobuf field: c1.api.task.v1.AllFilterMode all = 9
         */
        all: AllFilterMode;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.task.v1.SearchCertifyTicketsByUserViewResponse
 */
export interface SearchCertifyTicketsByUserViewResponse {
    /**
     * List of task views containing the certify tasks.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.TaskView list = 1
     */
    list: TaskView[];
    /**
     * The list of expanded related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.task.v1.CountOpenExtensionTicketsRequest
 */
export interface CountOpenExtensionTicketsRequest {
    /**
     * Optional app ID to filter by.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * Response message for CountOpenExtensionTickets RPC.
 *
 * @generated from protobuf message c1.api.task.v1.CountOpenExtensionTicketsResponse
 */
export interface CountOpenExtensionTicketsResponse {
    /**
     * The count of open extension tickets.
     *
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * Request message for ListOpenExtensionTickets RPC.
 *
 * @generated from protobuf message c1.api.task.v1.ListOpenExtensionTicketsRequest
 */
export interface ListOpenExtensionTicketsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Optional app ID to filter by.
     *
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
}
/**
 * An open extension ticket with its associated expiring binding.
 *
 * @generated from protobuf message c1.api.task.v1.OpenExtensionTicketWithBinding
 */
export interface OpenExtensionTicketWithBinding {
    /**
     * The extension ticket.
     *
     * @generated from protobuf field: c1.api.task.v1.Task task = 1
     */
    task?: Task;
    /**
     * The expiring app entitlement user binding associated with this ticket.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 2
     */
    binding?: AppEntitlementUserBinding;
}
/**
 * Response message for ListOpenExtensionTickets RPC.
 *
 * @generated from protobuf message c1.api.task.v1.ListOpenExtensionTicketsResponse
 */
export interface ListOpenExtensionTicketsResponse {
    /**
     * List of open extension tickets with their expiring bindings.
     *
     * @generated from protobuf field: repeated c1.api.task.v1.OpenExtensionTicketWithBinding list = 1
     */
    list: OpenExtensionTicketWithBinding[];
    /**
     * The next page token for pagination.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * From c1.api.app.v1.AppUserType.
 *
 * @generated from protobuf enum c1.api.task.v1.AppUserType
 */
export enum AppUserType {
    /**
     * User type is not specified. This should be considered an invalid state in a response.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Identifies the user as a person.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_USER = 1;
     */
    USER = 1,
    /**
     * Identifies the user as a service.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_SERVICE_ACCOUNT = 2;
     */
    SERVICE_ACCOUNT = 2,
    /**
     * Identifies the user as a system.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_SYSTEM_ACCOUNT = 3;
     */
    SYSTEM_ACCOUNT = 3
}
/**
 * Filter tasks by pending action status (for access review campaigns).
 *
 * @generated from protobuf enum c1.api.task.v1.PendingActionFilter
 */
export enum PendingActionFilter {
    /**
     * No filtering by pending action status.
     *
     * @generated from protobuf enum value: PENDING_ACTION_FILTER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Only show tasks that have a pending action queued.
     *
     * @generated from protobuf enum value: PENDING_ACTION_FILTER_WITH_PENDING = 1;
     */
    WITH_PENDING = 1,
    /**
     * Only show tasks that do not have a pending action queued.
     *
     * @generated from protobuf enum value: PENDING_ACTION_FILTER_WITHOUT_PENDING = 2;
     */
    WITHOUT_PENDING = 2
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskSearchSortBy
 */
export enum TaskSearchSortBy {
    /**
     * Defaults to sorting return values by the Ticket ID if unspecified.
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Sort return values by the accounts that are the subject.
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_ACCOUNT = 1;
     */
    ACCOUNT = 1,
    /**
     * Sort return values by the resource they're targeting.
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_RESOURCE = 2;
     */
    RESOURCE = 2,
    /**
     * Sort return values by the account owner.
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_ACCOUNT_OWNER = 3;
     */
    ACCOUNT_OWNER = 3,
    /**
     * Sort return values by the reverse ticket ID.
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_REVERSE_TICKET_ID = 4;
     */
    REVERSE_TICKET_ID = 4,
    /**
     * Sort return values by the ticket ID (default)
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_TICKET_ID = 5;
     */
    TICKET_ID = 5,
    /**
     * Sort return values by the created_at timestamp.
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_CREATED_AT = 6;
     */
    CREATED_AT = 6,
    /**
     * Sort return values by the created_at timestamp (reversed).
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_REVERSE_CREATED_AT = 7;
     */
    REVERSE_CREATED_AT = 7,
    /**
     * Sort return values by the app resource ID and app entitlement display name.
     *
     * @generated from protobuf enum value: TASK_SEARCH_SORT_BY_APP_RESOURCE_ID_AND_APP_ENTITLEMENT = 8;
     */
    APP_RESOURCE_ID_AND_APP_ENTITLEMENT = 8
}
/**
 * @generated from protobuf enum c1.api.task.v1.TaskSearchCurrentStep
 */
export enum TaskSearchCurrentStep {
    /**
     * @generated from protobuf enum value: TASK_SEARCH_CURRENT_STEP_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Search tasks where the current step is an approval step.
     *
     * @generated from protobuf enum value: TASK_SEARCH_CURRENT_STEP_APPROVAL = 1;
     */
    APPROVAL = 1,
    /**
     * Search tasks where the current step is a provision step.
     *
     * @generated from protobuf enum value: TASK_SEARCH_CURRENT_STEP_PROVISION = 2;
     */
    PROVISION = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchWaitingOnRequest$Type extends MessageType<SearchWaitingOnRequest> {
    constructor() {
        super("c1.api.task.v1.SearchWaitingOnRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => TaskExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchWaitingOnRequest>): SearchWaitingOnRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchWaitingOnRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchWaitingOnRequest): SearchWaitingOnRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 2:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchWaitingOnRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 2; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.SearchWaitingOnRequest
 */
export const SearchWaitingOnRequest = new SearchWaitingOnRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchWaitingOnResponse$Type extends MessageType<SearchWaitingOnResponse> {
    constructor() {
        super("c1.api.task.v1.SearchWaitingOnResponse", [
            { no: 1, name: "waiting_on_tasks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchWaitingOnResponse>): SearchWaitingOnResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.waitingOnTasks = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchWaitingOnResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchWaitingOnResponse): SearchWaitingOnResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskView waiting_on_tasks */ 1:
                    message.waitingOnTasks.push(TaskView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchWaitingOnResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskView waiting_on_tasks = 1; */
        for (let i = 0; i < message.waitingOnTasks.length; i++)
            TaskView.internalBinaryWrite(message.waitingOnTasks[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.SearchWaitingOnResponse
 */
export const SearchWaitingOnResponse = new SearchWaitingOnResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAuditEventTypeErrorRequest$Type extends MessageType<CountAuditEventTypeErrorRequest> {
    constructor() {
        super("c1.api.task.v1.CountAuditEventTypeErrorRequest", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<CountAuditEventTypeErrorRequest>): CountAuditEventTypeErrorRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.taskId = "";
        if (value !== undefined)
            reflectionMergePartial<CountAuditEventTypeErrorRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountAuditEventTypeErrorRequest): CountAuditEventTypeErrorRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string task_id */ 1:
                    message.taskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountAuditEventTypeErrorRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string task_id = 1; */
        if (message.taskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.taskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountAuditEventTypeErrorRequest
 */
export const CountAuditEventTypeErrorRequest = new CountAuditEventTypeErrorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAuditEventTypeErrorResponse$Type extends MessageType<CountAuditEventTypeErrorResponse> {
    constructor() {
        super("c1.api.task.v1.CountAuditEventTypeErrorResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountAuditEventTypeErrorResponse>): CountAuditEventTypeErrorResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountAuditEventTypeErrorResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountAuditEventTypeErrorResponse): CountAuditEventTypeErrorResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountAuditEventTypeErrorResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountAuditEventTypeErrorResponse
 */
export const CountAuditEventTypeErrorResponse = new CountAuditEventTypeErrorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountCompletedTicketsWithinMonthRequest$Type extends MessageType<CountCompletedTicketsWithinMonthRequest> {
    constructor() {
        super("c1.api.task.v1.CountCompletedTicketsWithinMonthRequest", [
            { no: 1, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<CountCompletedTicketsWithinMonthRequest>): CountCompletedTicketsWithinMonthRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<CountCompletedTicketsWithinMonthRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountCompletedTicketsWithinMonthRequest): CountCompletedTicketsWithinMonthRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string userId */ 1:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountCompletedTicketsWithinMonthRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string userId = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountCompletedTicketsWithinMonthRequest
 */
export const CountCompletedTicketsWithinMonthRequest = new CountCompletedTicketsWithinMonthRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountCompletedTicketsWithinMonthResponse$Type extends MessageType<CountCompletedTicketsWithinMonthResponse> {
    constructor() {
        super("c1.api.task.v1.CountCompletedTicketsWithinMonthResponse", [
            { no: 1, name: "Count", kind: "scalar", jsonName: "Count", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountCompletedTicketsWithinMonthResponse>): CountCompletedTicketsWithinMonthResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountCompletedTicketsWithinMonthResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountCompletedTicketsWithinMonthResponse): CountCompletedTicketsWithinMonthResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 Count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountCompletedTicketsWithinMonthResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 Count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountCompletedTicketsWithinMonthResponse
 */
export const CountCompletedTicketsWithinMonthResponse = new CountCompletedTicketsWithinMonthResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchTermsRequest$Type extends MessageType<TaskSearchTermsRequest> {
    constructor() {
        super("c1.api.task.v1.TaskSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => TaskSearchRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.task.v1.TaskSearchTermsRequest.TermType", TaskSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TaskSearchTermsRequest>): TaskSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<TaskSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchTermsRequest): TaskSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskSearchRequest search */ 1:
                    message.search = TaskSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.task.v1.TaskSearchTermsRequest.TermType term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskSearchRequest search = 1; */
        if (message.search)
            TaskSearchRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskSearchTermsRequest.TermType term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchTermsRequest
 */
export const TaskSearchTermsRequest = new TaskSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchTermsResponse$Type extends MessageType<SearchTermsResponse> {
    constructor() {
        super("c1.api.task.v1.SearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchTermsResponse>): SearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchTermsResponse): SearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.SearchTermsResponse
 */
export const SearchTermsResponse = new SearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchCountRequest$Type extends MessageType<TaskSearchCountRequest> {
    constructor() {
        super("c1.api.task.v1.TaskSearchCountRequest", [
            { no: 1, name: "filter", kind: "message", T: () => TaskSearchRequest }
        ]);
    }
    create(value?: PartialMessage<TaskSearchCountRequest>): TaskSearchCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskSearchCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchCountRequest): TaskSearchCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskSearchRequest filter */ 1:
                    message.filter = TaskSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskSearchRequest filter = 1; */
        if (message.filter)
            TaskSearchRequest.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchCountRequest
 */
export const TaskSearchCountRequest = new TaskSearchCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchCountByTypeRequest$Type extends MessageType<TaskSearchCountByTypeRequest> {
    constructor() {
        super("c1.api.task.v1.TaskSearchCountByTypeRequest", [
            { no: 1, name: "filter", kind: "message", T: () => TaskSearchRequest }
        ]);
    }
    create(value?: PartialMessage<TaskSearchCountByTypeRequest>): TaskSearchCountByTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TaskSearchCountByTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchCountByTypeRequest): TaskSearchCountByTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TaskSearchRequest filter */ 1:
                    message.filter = TaskSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchCountByTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TaskSearchRequest filter = 1; */
        if (message.filter)
            TaskSearchRequest.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchCountByTypeRequest
 */
export const TaskSearchCountByTypeRequest = new TaskSearchCountByTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchRequest$Type extends MessageType<TaskSearchRequest> {
    constructor() {
        super("c1.api.task.v1.TaskSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "task_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskType, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { message: { required: true } } } } } },
            { no: 8, name: "task_states", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.TaskState", TaskState, "TASK_STATE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "application_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "opener_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "subject_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 12, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 15, name: "access_review_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 16, name: "app_user_subject_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 20, name: "created_before", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false, ltNow: true } } } },
            { no: 21, name: "created_after", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false, ltNow: true } } } },
            { no: 22, name: "assignees_in_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 23, name: "previously_acted_on_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 24, name: "app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 34, name: "exclude_app_entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 25, name: "app_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 26, name: "app_resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 27, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 28, name: "my_work_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 29, name: "sort_by", kind: "enum", T: () => ["c1.api.task.v1.TaskSearchSortBy", TaskSearchSortBy, "TASK_SEARCH_SORT_BY_"] },
            { no: 30, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "current_step", kind: "enum", T: () => ["c1.api.task.v1.TaskSearchCurrentStep", TaskSearchCurrentStep, "TASK_SEARCH_CURRENT_STEP_"] },
            { no: 32, name: "account_owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 33, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } },
            { no: 35, name: "emergency_status", kind: "enum", T: () => ["c1.api.task.v1.TaskSearchRequest.EmergencyStatusFilter", TaskSearchRequest_EmergencyStatusFilter] },
            { no: 36, name: "older_than_duration", kind: "message", T: () => Duration },
            { no: 37, name: "account_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 38, name: "exclude_app_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 39, name: "step_approval_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.policy.v1.StepApprovalType", StepApprovalType, "STEP_APPROVAL_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 40, name: "user_employment_statuses", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } },
            { no: 41, name: "opener_or_subject_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 42, name: "assigned_or_step_approver_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 43, name: "include_acted_after", kind: "message", T: () => Timestamp },
            { no: 44, name: "certify_outcomes", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.CertifyOutcome", CertifyOutcome, "CERTIFY_OUTCOME_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } },
            { no: 45, name: "outcome_after", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false, ltNow: true } } } },
            { no: 46, name: "outcome_before", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false, ltNow: true } } } },
            { no: 47, name: "grant_outcomes", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.GrantOutcome", GrantOutcome, "GRANT_OUTCOME_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } },
            { no: 48, name: "revoke_outcomes", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.RevokeOutcome", RevokeOutcome, "REVOKE_OUTCOME_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true } } } },
            { no: 49, name: "pending_action_filter", kind: "enum", T: () => ["c1.api.task.v1.PendingActionFilter", PendingActionFilter, "PENDING_ACTION_FILTER_"] }
        ]);
    }
    create(value?: PartialMessage<TaskSearchRequest>): TaskSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.excludeIds = [];
        message.taskTypes = [];
        message.taskStates = [];
        message.applicationIds = [];
        message.openerIds = [];
        message.subjectIds = [];
        message.accessReviewIds = [];
        message.appUserSubjectIds = [];
        message.assigneesInIds = [];
        message.previouslyActedOnIds = [];
        message.appEntitlementIds = [];
        message.excludeAppEntitlementIds = [];
        message.appResourceTypeIds = [];
        message.appResourceIds = [];
        message.includeDeleted = false;
        message.myWorkUserIds = [];
        message.sortBy = 0;
        message.actorId = "";
        message.currentStep = 0;
        message.accountOwnerIds = [];
        message.refs = [];
        message.emergencyStatus = 0;
        message.accountTypes = [];
        message.excludeAppResourceTypeIds = [];
        message.stepApprovalTypes = [];
        message.userEmploymentStatuses = [];
        message.openerOrSubjectUserId = "";
        message.assignedOrStepApproverUserId = "";
        message.certifyOutcomes = [];
        message.grantOutcomes = [];
        message.revokeOutcomes = [];
        message.pendingActionFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchRequest): TaskSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_ids */ 6:
                    message.excludeIds.push(reader.string());
                    break;
                case /* repeated c1.api.task.v1.TaskType task_types */ 7:
                    message.taskTypes.push(TaskType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.task.v1.TaskState task_states */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.taskStates.push(reader.int32());
                    else
                        message.taskStates.push(reader.int32());
                    break;
                case /* repeated string application_ids */ 9:
                    message.applicationIds.push(reader.string());
                    break;
                case /* repeated string opener_ids */ 10:
                    message.openerIds.push(reader.string());
                    break;
                case /* repeated string subject_ids */ 11:
                    message.subjectIds.push(reader.string());
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 12:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string access_review_ids */ 15:
                    message.accessReviewIds.push(reader.string());
                    break;
                case /* repeated string app_user_subject_ids */ 16:
                    message.appUserSubjectIds.push(reader.string());
                    break;
                case /* google.protobuf.Timestamp created_before */ 20:
                    message.createdBefore = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdBefore);
                    break;
                case /* google.protobuf.Timestamp created_after */ 21:
                    message.createdAfter = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAfter);
                    break;
                case /* repeated string assignees_in_ids */ 22:
                    message.assigneesInIds.push(reader.string());
                    break;
                case /* repeated string previously_acted_on_ids */ 23:
                    message.previouslyActedOnIds.push(reader.string());
                    break;
                case /* repeated string app_entitlement_ids */ 24:
                    message.appEntitlementIds.push(reader.string());
                    break;
                case /* repeated string exclude_app_entitlement_ids */ 34:
                    message.excludeAppEntitlementIds.push(reader.string());
                    break;
                case /* repeated string app_resource_type_ids */ 25:
                    message.appResourceTypeIds.push(reader.string());
                    break;
                case /* repeated string app_resource_ids */ 26:
                    message.appResourceIds.push(reader.string());
                    break;
                case /* bool include_deleted */ 27:
                    message.includeDeleted = reader.bool();
                    break;
                case /* repeated string my_work_user_ids */ 28:
                    message.myWorkUserIds.push(reader.string());
                    break;
                case /* c1.api.task.v1.TaskSearchSortBy sort_by */ 29:
                    message.sortBy = reader.int32();
                    break;
                case /* string actor_id */ 30:
                    message.actorId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskSearchCurrentStep current_step */ 31:
                    message.currentStep = reader.int32();
                    break;
                case /* repeated string account_owner_ids */ 32:
                    message.accountOwnerIds.push(reader.string());
                    break;
                case /* repeated c1.api.task.v1.TaskRef refs */ 33:
                    message.refs.push(TaskRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.task.v1.TaskSearchRequest.EmergencyStatusFilter emergency_status */ 35:
                    message.emergencyStatus = reader.int32();
                    break;
                case /* google.protobuf.Duration older_than_duration */ 36:
                    message.olderThanDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.olderThanDuration);
                    break;
                case /* repeated c1.api.task.v1.AppUserType account_types */ 37:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountTypes.push(reader.int32());
                    else
                        message.accountTypes.push(reader.int32());
                    break;
                case /* repeated string exclude_app_resource_type_ids */ 38:
                    message.excludeAppResourceTypeIds.push(reader.string());
                    break;
                case /* repeated c1.api.policy.v1.StepApprovalType step_approval_types */ 39:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.stepApprovalTypes.push(reader.int32());
                    else
                        message.stepApprovalTypes.push(reader.int32());
                    break;
                case /* repeated string user_employment_statuses */ 40:
                    message.userEmploymentStatuses.push(reader.string());
                    break;
                case /* string opener_or_subject_user_id */ 41:
                    message.openerOrSubjectUserId = reader.string();
                    break;
                case /* string assigned_or_step_approver_user_id */ 42:
                    message.assignedOrStepApproverUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp include_acted_after */ 43:
                    message.includeActedAfter = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.includeActedAfter);
                    break;
                case /* repeated c1.api.task.v1.CertifyOutcome certify_outcomes */ 44:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.certifyOutcomes.push(reader.int32());
                    else
                        message.certifyOutcomes.push(reader.int32());
                    break;
                case /* google.protobuf.Timestamp outcome_after */ 45:
                    message.outcomeAfter = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.outcomeAfter);
                    break;
                case /* google.protobuf.Timestamp outcome_before */ 46:
                    message.outcomeBefore = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.outcomeBefore);
                    break;
                case /* repeated c1.api.task.v1.GrantOutcome grant_outcomes */ 47:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.grantOutcomes.push(reader.int32());
                    else
                        message.grantOutcomes.push(reader.int32());
                    break;
                case /* repeated c1.api.task.v1.RevokeOutcome revoke_outcomes */ 48:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.revokeOutcomes.push(reader.int32());
                    else
                        message.revokeOutcomes.push(reader.int32());
                    break;
                case /* c1.api.task.v1.PendingActionFilter pending_action_filter */ 49:
                    message.pendingActionFilter = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_ids = 6; */
        for (let i = 0; i < message.excludeIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.excludeIds[i]);
        /* repeated c1.api.task.v1.TaskType task_types = 7; */
        for (let i = 0; i < message.taskTypes.length; i++)
            TaskType.internalBinaryWrite(message.taskTypes[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.task.v1.TaskState task_states = 8; */
        if (message.taskStates.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.taskStates.length; i++)
                writer.int32(message.taskStates[i]);
            writer.join();
        }
        /* repeated string application_ids = 9; */
        for (let i = 0; i < message.applicationIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.applicationIds[i]);
        /* repeated string opener_ids = 10; */
        for (let i = 0; i < message.openerIds.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.openerIds[i]);
        /* repeated string subject_ids = 11; */
        for (let i = 0; i < message.subjectIds.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.subjectIds[i]);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 12; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated string access_review_ids = 15; */
        for (let i = 0; i < message.accessReviewIds.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.accessReviewIds[i]);
        /* repeated string app_user_subject_ids = 16; */
        for (let i = 0; i < message.appUserSubjectIds.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.appUserSubjectIds[i]);
        /* google.protobuf.Timestamp created_before = 20; */
        if (message.createdBefore)
            Timestamp.internalBinaryWrite(message.createdBefore, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_after = 21; */
        if (message.createdAfter)
            Timestamp.internalBinaryWrite(message.createdAfter, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* repeated string assignees_in_ids = 22; */
        for (let i = 0; i < message.assigneesInIds.length; i++)
            writer.tag(22, WireType.LengthDelimited).string(message.assigneesInIds[i]);
        /* repeated string previously_acted_on_ids = 23; */
        for (let i = 0; i < message.previouslyActedOnIds.length; i++)
            writer.tag(23, WireType.LengthDelimited).string(message.previouslyActedOnIds[i]);
        /* repeated string app_entitlement_ids = 24; */
        for (let i = 0; i < message.appEntitlementIds.length; i++)
            writer.tag(24, WireType.LengthDelimited).string(message.appEntitlementIds[i]);
        /* repeated string app_resource_type_ids = 25; */
        for (let i = 0; i < message.appResourceTypeIds.length; i++)
            writer.tag(25, WireType.LengthDelimited).string(message.appResourceTypeIds[i]);
        /* repeated string app_resource_ids = 26; */
        for (let i = 0; i < message.appResourceIds.length; i++)
            writer.tag(26, WireType.LengthDelimited).string(message.appResourceIds[i]);
        /* bool include_deleted = 27; */
        if (message.includeDeleted !== false)
            writer.tag(27, WireType.Varint).bool(message.includeDeleted);
        /* repeated string my_work_user_ids = 28; */
        for (let i = 0; i < message.myWorkUserIds.length; i++)
            writer.tag(28, WireType.LengthDelimited).string(message.myWorkUserIds[i]);
        /* c1.api.task.v1.TaskSearchSortBy sort_by = 29; */
        if (message.sortBy !== 0)
            writer.tag(29, WireType.Varint).int32(message.sortBy);
        /* string actor_id = 30; */
        if (message.actorId !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.actorId);
        /* c1.api.task.v1.TaskSearchCurrentStep current_step = 31; */
        if (message.currentStep !== 0)
            writer.tag(31, WireType.Varint).int32(message.currentStep);
        /* repeated string account_owner_ids = 32; */
        for (let i = 0; i < message.accountOwnerIds.length; i++)
            writer.tag(32, WireType.LengthDelimited).string(message.accountOwnerIds[i]);
        /* repeated c1.api.task.v1.TaskRef refs = 33; */
        for (let i = 0; i < message.refs.length; i++)
            TaskRef.internalBinaryWrite(message.refs[i], writer.tag(33, WireType.LengthDelimited).fork(), options).join();
        /* repeated string exclude_app_entitlement_ids = 34; */
        for (let i = 0; i < message.excludeAppEntitlementIds.length; i++)
            writer.tag(34, WireType.LengthDelimited).string(message.excludeAppEntitlementIds[i]);
        /* c1.api.task.v1.TaskSearchRequest.EmergencyStatusFilter emergency_status = 35; */
        if (message.emergencyStatus !== 0)
            writer.tag(35, WireType.Varint).int32(message.emergencyStatus);
        /* google.protobuf.Duration older_than_duration = 36; */
        if (message.olderThanDuration)
            Duration.internalBinaryWrite(message.olderThanDuration, writer.tag(36, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.task.v1.AppUserType account_types = 37; */
        if (message.accountTypes.length) {
            writer.tag(37, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountTypes.length; i++)
                writer.int32(message.accountTypes[i]);
            writer.join();
        }
        /* repeated string exclude_app_resource_type_ids = 38; */
        for (let i = 0; i < message.excludeAppResourceTypeIds.length; i++)
            writer.tag(38, WireType.LengthDelimited).string(message.excludeAppResourceTypeIds[i]);
        /* repeated c1.api.policy.v1.StepApprovalType step_approval_types = 39; */
        if (message.stepApprovalTypes.length) {
            writer.tag(39, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.stepApprovalTypes.length; i++)
                writer.int32(message.stepApprovalTypes[i]);
            writer.join();
        }
        /* repeated string user_employment_statuses = 40; */
        for (let i = 0; i < message.userEmploymentStatuses.length; i++)
            writer.tag(40, WireType.LengthDelimited).string(message.userEmploymentStatuses[i]);
        /* string opener_or_subject_user_id = 41; */
        if (message.openerOrSubjectUserId !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.openerOrSubjectUserId);
        /* string assigned_or_step_approver_user_id = 42; */
        if (message.assignedOrStepApproverUserId !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.assignedOrStepApproverUserId);
        /* google.protobuf.Timestamp include_acted_after = 43; */
        if (message.includeActedAfter)
            Timestamp.internalBinaryWrite(message.includeActedAfter, writer.tag(43, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.task.v1.CertifyOutcome certify_outcomes = 44; */
        if (message.certifyOutcomes.length) {
            writer.tag(44, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.certifyOutcomes.length; i++)
                writer.int32(message.certifyOutcomes[i]);
            writer.join();
        }
        /* google.protobuf.Timestamp outcome_after = 45; */
        if (message.outcomeAfter)
            Timestamp.internalBinaryWrite(message.outcomeAfter, writer.tag(45, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp outcome_before = 46; */
        if (message.outcomeBefore)
            Timestamp.internalBinaryWrite(message.outcomeBefore, writer.tag(46, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.task.v1.GrantOutcome grant_outcomes = 47; */
        if (message.grantOutcomes.length) {
            writer.tag(47, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.grantOutcomes.length; i++)
                writer.int32(message.grantOutcomes[i]);
            writer.join();
        }
        /* repeated c1.api.task.v1.RevokeOutcome revoke_outcomes = 48; */
        if (message.revokeOutcomes.length) {
            writer.tag(48, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.revokeOutcomes.length; i++)
                writer.int32(message.revokeOutcomes[i]);
            writer.join();
        }
        /* c1.api.task.v1.PendingActionFilter pending_action_filter = 49; */
        if (message.pendingActionFilter !== 0)
            writer.tag(49, WireType.Varint).int32(message.pendingActionFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchRequest
 */
export const TaskSearchRequest = new TaskSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllAppsForTaskSearchRequest$Type extends MessageType<GetAllAppsForTaskSearchRequest> {
    constructor() {
        super("c1.api.task.v1.GetAllAppsForTaskSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "task_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskType, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 4, name: "task_states", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.task.v1.TaskState", TaskState, "TASK_STATE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "opener_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "subject_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "access_review_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 9, name: "created_before", kind: "message", T: () => Timestamp },
            { no: 10, name: "created_after", kind: "message", T: () => Timestamp },
            { no: 12, name: "assignees_in_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 13, name: "previously_acted_on_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<GetAllAppsForTaskSearchRequest>): GetAllAppsForTaskSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.excludeIds = [];
        message.taskTypes = [];
        message.taskStates = [];
        message.openerIds = [];
        message.subjectIds = [];
        message.accessReviewIds = [];
        message.assigneesInIds = [];
        message.previouslyActedOnIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllAppsForTaskSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllAppsForTaskSearchRequest): GetAllAppsForTaskSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_ids */ 2:
                    message.excludeIds.push(reader.string());
                    break;
                case /* repeated c1.api.task.v1.TaskType task_types */ 3:
                    message.taskTypes.push(TaskType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.task.v1.TaskState task_states */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.taskStates.push(reader.int32());
                    else
                        message.taskStates.push(reader.int32());
                    break;
                case /* repeated string opener_ids */ 5:
                    message.openerIds.push(reader.string());
                    break;
                case /* repeated string subject_ids */ 6:
                    message.subjectIds.push(reader.string());
                    break;
                case /* repeated string access_review_ids */ 7:
                    message.accessReviewIds.push(reader.string());
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 8:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* google.protobuf.Timestamp created_before */ 9:
                    message.createdBefore = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdBefore);
                    break;
                case /* google.protobuf.Timestamp created_after */ 10:
                    message.createdAfter = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAfter);
                    break;
                case /* repeated string assignees_in_ids */ 12:
                    message.assigneesInIds.push(reader.string());
                    break;
                case /* repeated string previously_acted_on_ids */ 13:
                    message.previouslyActedOnIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllAppsForTaskSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_ids = 2; */
        for (let i = 0; i < message.excludeIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.excludeIds[i]);
        /* repeated c1.api.task.v1.TaskType task_types = 3; */
        for (let i = 0; i < message.taskTypes.length; i++)
            TaskType.internalBinaryWrite(message.taskTypes[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.task.v1.TaskState task_states = 4; */
        if (message.taskStates.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.taskStates.length; i++)
                writer.int32(message.taskStates[i]);
            writer.join();
        }
        /* repeated string opener_ids = 5; */
        for (let i = 0; i < message.openerIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.openerIds[i]);
        /* repeated string subject_ids = 6; */
        for (let i = 0; i < message.subjectIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.subjectIds[i]);
        /* repeated string access_review_ids = 7; */
        for (let i = 0; i < message.accessReviewIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.accessReviewIds[i]);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 8; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_before = 9; */
        if (message.createdBefore)
            Timestamp.internalBinaryWrite(message.createdBefore, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_after = 10; */
        if (message.createdAfter)
            Timestamp.internalBinaryWrite(message.createdAfter, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated string assignees_in_ids = 12; */
        for (let i = 0; i < message.assigneesInIds.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.assigneesInIds[i]);
        /* repeated string previously_acted_on_ids = 13; */
        for (let i = 0; i < message.previouslyActedOnIds.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.previouslyActedOnIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.GetAllAppsForTaskSearchRequest
 */
export const GetAllAppsForTaskSearchRequest = new GetAllAppsForTaskSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllAppsForTaskSearchResponse$Type extends MessageType<GetAllAppsForTaskSearchResponse> {
    constructor() {
        super("c1.api.task.v1.GetAllAppsForTaskSearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App }
        ]);
    }
    create(value?: PartialMessage<GetAllAppsForTaskSearchResponse>): GetAllAppsForTaskSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<GetAllAppsForTaskSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAllAppsForTaskSearchResponse): GetAllAppsForTaskSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.App items */ 1:
                    message.items.push(App.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAllAppsForTaskSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.App items = 1; */
        for (let i = 0; i < message.items.length; i++)
            App.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.GetAllAppsForTaskSearchResponse
 */
export const GetAllAppsForTaskSearchResponse = new GetAllAppsForTaskSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchResponse$Type extends MessageType<TaskSearchResponse> {
    constructor() {
        super("c1.api.task.v1.TaskSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskSearchResponse>): TaskSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchResponse): TaskSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskView list */ 1:
                    message.list.push(TaskView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchResponse
 */
export const TaskSearchResponse = new TaskSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchCountResponse$Type extends MessageType<TaskSearchCountResponse> {
    constructor() {
        super("c1.api.task.v1.TaskSearchCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TaskSearchCountResponse>): TaskSearchCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskSearchCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchCountResponse): TaskSearchCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchCountResponse
 */
export const TaskSearchCountResponse = new TaskSearchCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchCountByTypeResponse$Type extends MessageType<TaskSearchCountByTypeResponse> {
    constructor() {
        super("c1.api.task.v1.TaskSearchCountByTypeResponse", [
            { no: 1, name: "counts_by_type", kind: "message", T: () => TicketTypeCounts },
            { no: 2, name: "total_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TaskSearchCountByTypeResponse>): TaskSearchCountByTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskSearchCountByTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchCountByTypeResponse): TaskSearchCountByTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.TicketTypeCounts counts_by_type */ 1:
                    message.countsByType = TicketTypeCounts.internalBinaryRead(reader, reader.uint32(), options, message.countsByType);
                    break;
                case /* int64 total_count */ 2:
                    message.totalCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchCountByTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.TicketTypeCounts counts_by_type = 1; */
        if (message.countsByType)
            TicketTypeCounts.internalBinaryWrite(message.countsByType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchCountByTypeResponse
 */
export const TaskSearchCountByTypeResponse = new TaskSearchCountByTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketTypeCounts$Type extends MessageType<TicketTypeCounts> {
    constructor() {
        super("c1.api.task.v1.TicketTypeCounts", [
            { no: 1, name: "grant_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "revoke_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "certify_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TicketTypeCounts>): TicketTypeCounts {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.grantCount = 0;
        message.revokeCount = 0;
        message.certifyCount = 0;
        if (value !== undefined)
            reflectionMergePartial<TicketTypeCounts>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketTypeCounts): TicketTypeCounts {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 grant_count */ 1:
                    message.grantCount = reader.int64().toNumber();
                    break;
                case /* int64 revoke_count */ 2:
                    message.revokeCount = reader.int64().toNumber();
                    break;
                case /* int64 certify_count */ 3:
                    message.certifyCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketTypeCounts, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 grant_count = 1; */
        if (message.grantCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.grantCount);
        /* int64 revoke_count = 2; */
        if (message.revokeCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.revokeCount);
        /* int64 certify_count = 3; */
        if (message.certifyCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.certifyCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TicketTypeCounts
 */
export const TicketTypeCounts = new TicketTypeCounts$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchGetProgressRequest$Type extends MessageType<TaskSearchGetProgressRequest> {
    constructor() {
        super("c1.api.task.v1.TaskSearchGetProgressRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<TaskSearchGetProgressRequest>): TaskSearchGetProgressRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<TaskSearchGetProgressRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchGetProgressRequest): TaskSearchGetProgressRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string access_review_id */ 2:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchGetProgressRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string access_review_id = 2; */
        if (message.accessReviewId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchGetProgressRequest
 */
export const TaskSearchGetProgressRequest = new TaskSearchGetProgressRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchGetProgressResponse$Type extends MessageType<TaskSearchGetProgressResponse> {
    constructor() {
        super("c1.api.task.v1.TaskSearchGetProgressResponse", [
            { no: 1, name: "open_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "completed_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TaskSearchGetProgressResponse>): TaskSearchGetProgressResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.openCount = 0;
        message.completedCount = 0;
        if (value !== undefined)
            reflectionMergePartial<TaskSearchGetProgressResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchGetProgressResponse): TaskSearchGetProgressResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 open_count */ 1:
                    message.openCount = reader.int64().toNumber();
                    break;
                case /* int64 completed_count */ 2:
                    message.completedCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchGetProgressResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 open_count = 1; */
        if (message.openCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.openCount);
        /* int64 completed_count = 2; */
        if (message.completedCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.completedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchGetProgressResponse
 */
export const TaskSearchGetProgressResponse = new TaskSearchGetProgressResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchServiceSearchTasksByGrantsRequest$Type extends MessageType<TaskSearchServiceSearchTasksByGrantsRequest> {
    constructor() {
        super("c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 4, name: "task_type", kind: "message", T: () => TaskType, options: { "validate.rules": { message: { required: true } } } },
            { no: 5, name: "app_entitlement_user_binding_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
    create(value?: PartialMessage<TaskSearchServiceSearchTasksByGrantsRequest>): TaskSearchServiceSearchTasksByGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appEntitlementUserBindingRefs = [];
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<TaskSearchServiceSearchTasksByGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchServiceSearchTasksByGrantsRequest): TaskSearchServiceSearchTasksByGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 3:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* c1.api.task.v1.TaskType task_type */ 4:
                    message.taskType = TaskType.internalBinaryRead(reader, reader.uint32(), options, message.taskType);
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingRef app_entitlement_user_binding_refs */ 5:
                    message.appEntitlementUserBindingRefs.push(AppEntitlementUserBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.task.v1.TaskRef refs */ 6:
                    message.refs.push(TaskRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchServiceSearchTasksByGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.task.v1.TaskExpandMask expand_mask = 3; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskType task_type = 4; */
        if (message.taskType)
            TaskType.internalBinaryWrite(message.taskType, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementUserBindingRef app_entitlement_user_binding_refs = 5; */
        for (let i = 0; i < message.appEntitlementUserBindingRefs.length; i++)
            AppEntitlementUserBindingRef.internalBinaryWrite(message.appEntitlementUserBindingRefs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.task.v1.TaskRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            TaskRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsRequest
 */
export const TaskSearchServiceSearchTasksByGrantsRequest = new TaskSearchServiceSearchTasksByGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskSearchServiceSearchTasksByGrantsResponse$Type extends MessageType<TaskSearchServiceSearchTasksByGrantsResponse> {
    constructor() {
        super("c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TaskSearchServiceSearchTasksByGrantsResponse>): TaskSearchServiceSearchTasksByGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<TaskSearchServiceSearchTasksByGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TaskSearchServiceSearchTasksByGrantsResponse): TaskSearchServiceSearchTasksByGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskView list */ 1:
                    message.list.push(TaskView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TaskSearchServiceSearchTasksByGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.TaskSearchServiceSearchTasksByGrantsResponse
 */
export const TaskSearchServiceSearchTasksByGrantsResponse = new TaskSearchServiceSearchTasksByGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RollupEntitlementsWithTasksRequest$Type extends MessageType<RollupEntitlementsWithTasksRequest> {
    constructor() {
        super("c1.api.task.v1.RollupEntitlementsWithTasksRequest", [
            { no: 1, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 7, name: "task_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskType, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<RollupEntitlementsWithTasksRequest>): RollupEntitlementsWithTasksRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlements = [];
        message.appUserId = "";
        message.userId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.taskTypes = [];
        if (value !== undefined)
            reflectionMergePartial<RollupEntitlementsWithTasksRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RollupEntitlementsWithTasksRequest): RollupEntitlementsWithTasksRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlements */ 1:
                    message.entitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* string user_id */ 3:
                    message.userId = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.task.v1.TaskRef refs */ 6:
                    message.refs.push(TaskRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.task.v1.TaskType task_types */ 7:
                    message.taskTypes.push(TaskType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RollupEntitlementsWithTasksRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef entitlements = 1; */
        for (let i = 0; i < message.entitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlements[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* string user_id = 3; */
        if (message.userId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userId);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.task.v1.TaskRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            TaskRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.task.v1.TaskType task_types = 7; */
        for (let i = 0; i < message.taskTypes.length; i++)
            TaskType.internalBinaryWrite(message.taskTypes[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.RollupEntitlementsWithTasksRequest
 */
export const RollupEntitlementsWithTasksRequest = new RollupEntitlementsWithTasksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RollupEntitlementsWithTasksResponse$Type extends MessageType<RollupEntitlementsWithTasksResponse> {
    constructor() {
        super("c1.api.task.v1.RollupEntitlementsWithTasksResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MinTask },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RollupEntitlementsWithTasksResponse>): RollupEntitlementsWithTasksResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RollupEntitlementsWithTasksResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RollupEntitlementsWithTasksResponse): RollupEntitlementsWithTasksResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.MinTask list */ 1:
                    message.list.push(MinTask.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RollupEntitlementsWithTasksResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.MinTask list = 1; */
        for (let i = 0; i < message.list.length; i++)
            MinTask.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.RollupEntitlementsWithTasksResponse
 */
export const RollupEntitlementsWithTasksResponse = new RollupEntitlementsWithTasksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MinTask$Type extends MessageType<MinTask> {
    constructor() {
        super("c1.api.task.v1.MinTask", [
            { no: 1, name: "numeric_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "task_type", kind: "message", T: () => TaskType }
        ]);
    }
    create(value?: PartialMessage<MinTask>): MinTask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.numericId = 0;
        message.id = "";
        message.entitlementId = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<MinTask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MinTask): MinTask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 numeric_id */ 1:
                    message.numericId = reader.int64().toNumber();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* string entitlement_id */ 3:
                    message.entitlementId = reader.string();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* c1.api.task.v1.TaskType task_type */ 5:
                    message.taskType = TaskType.internalBinaryRead(reader, reader.uint32(), options, message.taskType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MinTask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 numeric_id = 1; */
        if (message.numericId !== 0)
            writer.tag(1, WireType.Varint).int64(message.numericId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* string entitlement_id = 3; */
        if (message.entitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementId);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* c1.api.task.v1.TaskType task_type = 5; */
        if (message.taskType)
            TaskType.internalBinaryWrite(message.taskType, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.MinTask
 */
export const MinTask = new MinTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCertifyTicketsByAppViewRequest$Type extends MessageType<SearchCertifyTicketsByAppViewRequest> {
    constructor() {
        super("c1.api.task.v1.SearchCertifyTicketsByAppViewRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 7, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 8, name: "incomplete", kind: "message", oneof: "filterMode", T: () => IncompleteFilterMode },
            { no: 9, name: "all", kind: "message", oneof: "filterMode", T: () => AllFilterMode }
        ]);
    }
    create(value?: PartialMessage<SearchCertifyTicketsByAppViewRequest>): SearchCertifyTicketsByAppViewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.refs = [];
        message.accessReviewId = "";
        message.filterMode = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SearchCertifyTicketsByAppViewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCertifyTicketsByAppViewRequest): SearchCertifyTicketsByAppViewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* repeated c1.api.task.v1.TaskRef refs */ 5:
                    message.refs.push(TaskRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 6:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string access_review_id */ 7:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.task.v1.IncompleteFilterMode incomplete */ 8:
                    message.filterMode = {
                        oneofKind: "incomplete",
                        incomplete: IncompleteFilterMode.internalBinaryRead(reader, reader.uint32(), options, (message.filterMode as any).incomplete)
                    };
                    break;
                case /* c1.api.task.v1.AllFilterMode all */ 9:
                    message.filterMode = {
                        oneofKind: "all",
                        all: AllFilterMode.internalBinaryRead(reader, reader.uint32(), options, (message.filterMode as any).all)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCertifyTicketsByAppViewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* repeated c1.api.task.v1.TaskRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            TaskRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskExpandMask expand_mask = 6; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string access_review_id = 7; */
        if (message.accessReviewId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.task.v1.IncompleteFilterMode incomplete = 8; */
        if (message.filterMode.oneofKind === "incomplete")
            IncompleteFilterMode.internalBinaryWrite(message.filterMode.incomplete, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.AllFilterMode all = 9; */
        if (message.filterMode.oneofKind === "all")
            AllFilterMode.internalBinaryWrite(message.filterMode.all, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.SearchCertifyTicketsByAppViewRequest
 */
export const SearchCertifyTicketsByAppViewRequest = new SearchCertifyTicketsByAppViewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncompleteFilterMode$Type extends MessageType<IncompleteFilterMode> {
    constructor() {
        super("c1.api.task.v1.IncompleteFilterMode", [
            { no: 1, name: "acted_after", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } }
        ]);
    }
    create(value?: PartialMessage<IncompleteFilterMode>): IncompleteFilterMode {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<IncompleteFilterMode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IncompleteFilterMode): IncompleteFilterMode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp acted_after */ 1:
                    message.actedAfter = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.actedAfter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IncompleteFilterMode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp acted_after = 1; */
        if (message.actedAfter)
            Timestamp.internalBinaryWrite(message.actedAfter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.IncompleteFilterMode
 */
export const IncompleteFilterMode = new IncompleteFilterMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllFilterMode$Type extends MessageType<AllFilterMode> {
    constructor() {
        super("c1.api.task.v1.AllFilterMode", []);
    }
    create(value?: PartialMessage<AllFilterMode>): AllFilterMode {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AllFilterMode>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllFilterMode): AllFilterMode {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllFilterMode, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.AllFilterMode
 */
export const AllFilterMode = new AllFilterMode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCertifyTicketsByAppViewResponse$Type extends MessageType<SearchCertifyTicketsByAppViewResponse> {
    constructor() {
        super("c1.api.task.v1.SearchCertifyTicketsByAppViewResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCertifyTicketsByAppViewResponse>): SearchCertifyTicketsByAppViewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCertifyTicketsByAppViewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCertifyTicketsByAppViewResponse): SearchCertifyTicketsByAppViewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskView list */ 1:
                    message.list.push(TaskView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCertifyTicketsByAppViewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.SearchCertifyTicketsByAppViewResponse
 */
export const SearchCertifyTicketsByAppViewResponse = new SearchCertifyTicketsByAppViewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCertifyTicketsByUserViewRequest$Type extends MessageType<SearchCertifyTicketsByUserViewRequest> {
    constructor() {
        super("c1.api.task.v1.SearchCertifyTicketsByUserViewRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27})?$", ignoreEmpty: true } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => TaskExpandMask },
            { no: 7, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 8, name: "incomplete", kind: "message", oneof: "filterMode", T: () => IncompleteFilterMode },
            { no: 9, name: "all", kind: "message", oneof: "filterMode", T: () => AllFilterMode }
        ]);
    }
    create(value?: PartialMessage<SearchCertifyTicketsByUserViewRequest>): SearchCertifyTicketsByUserViewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.identityUserId = "";
        message.refs = [];
        message.accessReviewId = "";
        message.filterMode = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SearchCertifyTicketsByUserViewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCertifyTicketsByUserViewRequest): SearchCertifyTicketsByUserViewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string identity_user_id */ 3:
                    message.identityUserId = reader.string();
                    break;
                case /* repeated c1.api.task.v1.TaskRef refs */ 5:
                    message.refs.push(TaskRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.task.v1.TaskExpandMask expand_mask */ 6:
                    message.expandMask = TaskExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string access_review_id */ 7:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.task.v1.IncompleteFilterMode incomplete */ 8:
                    message.filterMode = {
                        oneofKind: "incomplete",
                        incomplete: IncompleteFilterMode.internalBinaryRead(reader, reader.uint32(), options, (message.filterMode as any).incomplete)
                    };
                    break;
                case /* c1.api.task.v1.AllFilterMode all */ 9:
                    message.filterMode = {
                        oneofKind: "all",
                        all: AllFilterMode.internalBinaryRead(reader, reader.uint32(), options, (message.filterMode as any).all)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCertifyTicketsByUserViewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string identity_user_id = 3; */
        if (message.identityUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identityUserId);
        /* repeated c1.api.task.v1.TaskRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            TaskRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.TaskExpandMask expand_mask = 6; */
        if (message.expandMask)
            TaskExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string access_review_id = 7; */
        if (message.accessReviewId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.task.v1.IncompleteFilterMode incomplete = 8; */
        if (message.filterMode.oneofKind === "incomplete")
            IncompleteFilterMode.internalBinaryWrite(message.filterMode.incomplete, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.AllFilterMode all = 9; */
        if (message.filterMode.oneofKind === "all")
            AllFilterMode.internalBinaryWrite(message.filterMode.all, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.SearchCertifyTicketsByUserViewRequest
 */
export const SearchCertifyTicketsByUserViewRequest = new SearchCertifyTicketsByUserViewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchCertifyTicketsByUserViewResponse$Type extends MessageType<SearchCertifyTicketsByUserViewResponse> {
    constructor() {
        super("c1.api.task.v1.SearchCertifyTicketsByUserViewResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaskView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchCertifyTicketsByUserViewResponse>): SearchCertifyTicketsByUserViewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchCertifyTicketsByUserViewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchCertifyTicketsByUserViewResponse): SearchCertifyTicketsByUserViewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.TaskView list */ 1:
                    message.list.push(TaskView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchCertifyTicketsByUserViewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.TaskView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TaskView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.SearchCertifyTicketsByUserViewResponse
 */
export const SearchCertifyTicketsByUserViewResponse = new SearchCertifyTicketsByUserViewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountOpenExtensionTicketsRequest$Type extends MessageType<CountOpenExtensionTicketsRequest> {
    constructor() {
        super("c1.api.task.v1.CountOpenExtensionTicketsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<CountOpenExtensionTicketsRequest>): CountOpenExtensionTicketsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<CountOpenExtensionTicketsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountOpenExtensionTicketsRequest): CountOpenExtensionTicketsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountOpenExtensionTicketsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountOpenExtensionTicketsRequest
 */
export const CountOpenExtensionTicketsRequest = new CountOpenExtensionTicketsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountOpenExtensionTicketsResponse$Type extends MessageType<CountOpenExtensionTicketsResponse> {
    constructor() {
        super("c1.api.task.v1.CountOpenExtensionTicketsResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountOpenExtensionTicketsResponse>): CountOpenExtensionTicketsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountOpenExtensionTicketsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountOpenExtensionTicketsResponse): CountOpenExtensionTicketsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountOpenExtensionTicketsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.CountOpenExtensionTicketsResponse
 */
export const CountOpenExtensionTicketsResponse = new CountOpenExtensionTicketsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOpenExtensionTicketsRequest$Type extends MessageType<ListOpenExtensionTicketsRequest> {
    constructor() {
        super("c1.api.task.v1.ListOpenExtensionTicketsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ListOpenExtensionTicketsRequest>): ListOpenExtensionTicketsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<ListOpenExtensionTicketsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOpenExtensionTicketsRequest): ListOpenExtensionTicketsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOpenExtensionTicketsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ListOpenExtensionTicketsRequest
 */
export const ListOpenExtensionTicketsRequest = new ListOpenExtensionTicketsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OpenExtensionTicketWithBinding$Type extends MessageType<OpenExtensionTicketWithBinding> {
    constructor() {
        super("c1.api.task.v1.OpenExtensionTicketWithBinding", [
            { no: 1, name: "task", kind: "message", T: () => Task },
            { no: 2, name: "binding", kind: "message", T: () => AppEntitlementUserBinding }
        ]);
    }
    create(value?: PartialMessage<OpenExtensionTicketWithBinding>): OpenExtensionTicketWithBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<OpenExtensionTicketWithBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OpenExtensionTicketWithBinding): OpenExtensionTicketWithBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.task.v1.Task task */ 1:
                    message.task = Task.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                case /* c1.api.app.v1.AppEntitlementUserBinding binding */ 2:
                    message.binding = AppEntitlementUserBinding.internalBinaryRead(reader, reader.uint32(), options, message.binding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OpenExtensionTicketWithBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.task.v1.Task task = 1; */
        if (message.task)
            Task.internalBinaryWrite(message.task, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementUserBinding binding = 2; */
        if (message.binding)
            AppEntitlementUserBinding.internalBinaryWrite(message.binding, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.OpenExtensionTicketWithBinding
 */
export const OpenExtensionTicketWithBinding = new OpenExtensionTicketWithBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListOpenExtensionTicketsResponse$Type extends MessageType<ListOpenExtensionTicketsResponse> {
    constructor() {
        super("c1.api.task.v1.ListOpenExtensionTicketsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => OpenExtensionTicketWithBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListOpenExtensionTicketsResponse>): ListOpenExtensionTicketsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListOpenExtensionTicketsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListOpenExtensionTicketsResponse): ListOpenExtensionTicketsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.task.v1.OpenExtensionTicketWithBinding list */ 1:
                    message.list.push(OpenExtensionTicketWithBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListOpenExtensionTicketsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.task.v1.OpenExtensionTicketWithBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            OpenExtensionTicketWithBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.task.v1.ListOpenExtensionTicketsResponse
 */
export const ListOpenExtensionTicketsResponse = new ListOpenExtensionTicketsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.task.v1.TaskSearchService
 */
export const TaskSearchService = new ServiceType("c1.api.task.v1.TaskSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/tasks", group: "Task" }] } }, I: TaskSearchRequest, O: TaskSearchResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: TaskSearchTermsRequest, O: SearchTermsResponse },
    { name: "SearchCount", options: { "authz.method": { role: "VIEWER" } }, I: TaskSearchCountRequest, O: TaskSearchCountResponse },
    { name: "SearchCountByType", options: { "authz.method": { role: "VIEWER" } }, I: TaskSearchCountByTypeRequest, O: TaskSearchCountByTypeResponse },
    { name: "GetAllAppsForTaskSearch", options: { "authz.method": { role: "VIEWER" } }, I: GetAllAppsForTaskSearchRequest, O: GetAllAppsForTaskSearchResponse },
    { name: "GetProgress", options: { "authz.method": { role: "VIEWER" } }, I: TaskSearchGetProgressRequest, O: TaskSearchGetProgressResponse },
    { name: "CountCompletedTicketsWithinMonth", options: { "authz.method": { role: "VIEWER" } }, I: CountCompletedTicketsWithinMonthRequest, O: CountCompletedTicketsWithinMonthResponse },
    { name: "CountAuditEventTypeError", options: { "authz.method": { role: "VIEWER" } }, I: CountAuditEventTypeErrorRequest, O: CountAuditEventTypeErrorResponse },
    { name: "SearchTasksByGrants", options: { "authz.method": { role: "VIEWER" } }, I: TaskSearchServiceSearchTasksByGrantsRequest, O: TaskSearchServiceSearchTasksByGrantsResponse },
    { name: "SearchWaitingOn", options: { "authz.method": { role: "VIEWER" } }, I: SearchWaitingOnRequest, O: SearchWaitingOnResponse },
    { name: "RollupEntitlementsWithTasks", options: { "authz.method": { role: "VIEWER" } }, I: RollupEntitlementsWithTasksRequest, O: RollupEntitlementsWithTasksResponse },
    { name: "SearchCertifyTicketsByAppView", options: { "authz.method": { role: "VIEWER" } }, I: SearchCertifyTicketsByAppViewRequest, O: SearchCertifyTicketsByAppViewResponse },
    { name: "SearchCertifyTicketsByUserView", options: { "authz.method": { role: "VIEWER" } }, I: SearchCertifyTicketsByUserViewRequest, O: SearchCertifyTicketsByUserViewResponse },
    { name: "CountOpenExtensionTickets", options: { "authz.method": { role: "VIEWER" } }, I: CountOpenExtensionTicketsRequest, O: CountOpenExtensionTicketsResponse },
    { name: "ListOpenExtensionTickets", options: { "authz.method": { role: "VIEWER" } }, I: ListOpenExtensionTicketsRequest, O: ListOpenExtensionTicketsResponse }
]);
